/**
 * iter-170e — Shared chart helpers extracted from CashForecastChart
 * and NetWorthChart to drop their cyclomatic complexity (36 / 23) by
 * deleting duplicated formatters and the range-picker pill row.
 *
 * Pure functions + tiny style constants. Zero React import — safe to
 * unit-test in isolation.
 */

/**
 * Compact number formatter for chart Y-axes.
 *
 *   1_500_000 → "1.5M"
 *   12_345    → "12k"
 *   -250      → "-250"
 */
export function formatCompactNumber(v) {
  const abs = Math.abs(v);
  if (abs >= 1_000_000) return `${(v / 1_000_000).toFixed(1)}M`;
  if (abs >= 1_000) return `${(v / 1_000).toFixed(0)}k`;
  return String(v);
}

/**
 * X-axis tick formatter for ISO date strings (``2026-06-15``).
 * Strips the year to show ``06-15``. Robust to non-strings.
 */
export function formatDayLabel(v) {
  if (typeof v !== "string") return String(v ?? "");
  return v.slice(5);
}

/**
 * Tooltip date formatter using the user's browser locale.
 */
export function formatDateTooltip(d) {
  try {
    return new Date(d).toLocaleDateString();
  } catch {
    return String(d ?? "");
  }
}

/** Recharts tick style shared by every Lumfi chart axis. */
export const CHART_TICK_STYLE = { fontSize: 11, fill: "#64748B" };

/** Recharts tooltip content style shared by every Lumfi chart. */
export const CHART_TOOLTIP_STYLE = {
  borderRadius: 12,
  border: "1px solid #E2E8F0",
  fontSize: 12,
};

/** Standard Recharts X/Y axis props block (axisLine/tickLine off). */
export const CHART_AXIS_PROPS = {
  tick: CHART_TICK_STYLE,
  axisLine: false,
  tickLine: false,
};
